import { gql } from "@apollo/client";

export const BOOK_DEMO = gql`
  mutation BookDemo($input: bookDemoInput) {
    bookDemo(input: $input)
  }
`;

export const CONTACT_US = gql`
  mutation ContactUs($input: contactInput) {
    contactUs(input: $input)
  }
`;

export const GET_BOOK_DEMO = gql`
  query getbookDemo {
    getbookDemo {
      name
      phoneNumber
      email
      noOfEmployees
      companyName
      comments
      designation
      websiteUrl
    }
  }
`;
